import React, {useState} from 'react';
import {useNavigate} from "react-router-dom";
import useAuthCalls from "../utilities/custom-hooks/auth-calls";
import {doPostLogin} from "../logic/auth";
import Layout from "../components/Layout/Layout";
import Form from "../components/Login/Form";
import {useDashboard} from "../utilities/context/dashboard/dashboard-context";

const Login = () => {

    const [loginError, setLoginError] = useState("");

    const navigate = useNavigate();

    const {setUserId} = useDashboard();
    const {call} = useAuthCalls();

    const goToRegistration = () => {
        navigate('/app/signup');
    }

    const goToForgotten = () => {
        navigate('../forgotten');
    }

    const handleSubmit = async (fields) => {

        await call(
            () => doPostLogin(fields),
            async (res) => {
                console.log(res);
                if (res.error) {
                    setLoginError(res.error);
                } else {
                    setLoginError("");
                    sessionStorage.setItem('@user_token', res.token);
                    if(res.user) {
                        await setUserId(res.user);
                    }
                    navigate('/dashboard');
                }
            },
            (e) => {
                setLoginError(e.message ?? "Errore di login");
            }
        );
    }

    return (
        <Layout current='/app/login'>
            <div className="flex flex-col items-center bg-ea_gray_dark flex-1 w-full min-h-screen">
                <div className="mt-8">
                    <div className="font-bold text-xl text-white">Accedi alla tua area riservata</div>
                    <Form onSubmit={handleSubmit} error={loginError}/>
                    <div className="cursor-pointer hover:underline text-sm text-white mt-4" onClick={goToRegistration}>
                        Non hai ancora un account? <b>Registrati!</b>
                    </div>
                    <div className="cursor-pointer hover:underline text-sm mt-2 text-white" onClick={goToForgotten}>
                        Hai dimenticato la password?
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Login;
